import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { RESCHEDULE_APPOINTMENT_BY_ID } from '../../queries/reschedule-appointment-by-id.js';
import { fromRescheduleAppointmentQueryToAppointment } from './adapters/fromRescheduleAppointmentQueryToAppointment.js';

const useRescheduleAppointmentById = (token = '')=>{
    const { locale  } = useIntl();
    const [query, queryState] = useMutation(RESCHEDULE_APPOINTMENT_BY_ID, {
        context: {
            fetchPolicy: 'no-cache',
            forwardHeaders: {
                'Accept-Language': locale,
                Authorization: `Bearer ${token}`
            },
            timeout: 60000
        },
        onError: (error)=>{
            console.error(`Error occurred while executing RESCHEDULE_APPOINTMENT_BY_ID mutation: `, error);
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return fromRescheduleAppointmentQueryToAppointment((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.rescheduleAppointment);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useRescheduleAppointmentById as default };
//# sourceMappingURL=use-reschedule-appointment-by-id.js.map
